/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { SignaturePadType } from '../../models/signature-pad-type';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface ExternalGetPdfForSignature$Params {
  signaturePadType: SignaturePadType;
  token: Token64LengthType;
}

export function externalGetPdfForSignature(http: HttpClient, rootUrl: string, params: ExternalGetPdfForSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, externalGetPdfForSignature.PATH, 'get');
  if (params) {
    rb.path('signaturePadType', params.signaturePadType, {});
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

externalGetPdfForSignature.PATH = '/external/signature-pads/{signaturePadType}/bundle-data/pdf';
